import React, { useEffect, useState } from 'react';
import connect from "react-redux/es/components/connect";
import { useNavigate } from "react-router-dom";
import Box from '@mui/system/Box';
import {
    FormControl, AccordionSummary, Accordion, AccordionDetails, Typography,
    Select, MenuItem, TextField, Button
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { getAccessRightsForPageID, actionGetTrancheList } from "../store/action/RemoteActionSupervisor";
import translate from "../i18n/translate";
import { resetTimout } from "./common/FirebaseSupervisor";
import { PAGEID, ACCESSRIGHTSTYPE } from "../i18n/constants";
import { getMultiLanguageMessage } from "../i18n/multiLanguage";

let BASE_URL = process.env.REACT_APP_SERVER_URL_API;

const TrancheList = (props) => {
    const navigate = useNavigate();
    const [message, setMessage] = useState("");
    const [language, setLanguage] = useState("");
    const [pageAccessRights, setPageAccessRights] = useState({});
    const [isError, setIsError] = useState(false);
    const [searchField, setSearchField] = useState(0);
    const [searchKeyword, setSearchKeyword] = useState('');

    const Message = ({ message }) => (
        <section>
            <p style={{ color: isError ? "red" : "blue" }}>{message}</p>
        </section>
    );

    const onClickSearch = () => {
        resetTimout();
        const requestBody = {
            SearchField: searchField,
            SearchKeyword: searchKeyword
        };
        props.actionGetTrancheList(requestBody);
    };

    const handleChange = (e) => {
        resetTimout();
        let eventValue = e.target.value;
        switch (e.target.name) {
            case "search-field":
                eventValue = parseInt(eventValue);
                setSearchField(eventValue);
                if (eventValue === 0) {
                    setSearchKeyword("");
                }
                break;
            case "search-keyword":
                setSearchKeyword(eventValue);
                break;
            default:
                console.log(e.target.name);
        }
    };

    const goToAddTranche = (e) => {
        resetTimout();
        window.location.href = '/addtranche';
    };

    const goToModiyTranche = (nTrancheID) => {
        resetTimout();
        navigate('/modifytranche?TID=' + nTrancheID);
    };

    useEffect(() => {
        let selectedLanguage = localStorage.getItem("locale");
        setLanguage(selectedLanguage);
        let accessRights = getAccessRightsForPageID(PAGEID.Tranche);
        setPageAccessRights(accessRights);
        if (accessRights && accessRights.ReadAccess === ACCESSRIGHTSTYPE.Yes) {
            const requestBody = {
                SearchField: 0,
                SearchKeyword: ''
            };
            props.actionGetTrancheList(requestBody);
        } else {
            alert(getMultiLanguageMessage('Msg_InvalidAccessRights', selectedLanguage));
        }
    }, []);

    return ((props?.supervisor?.length > 0 && pageAccessRights && pageAccessRights.ReadAccess === ACCESSRIGHTSTYPE.Yes)) ? (
        <div className="user-panel">
            <h2 className="user-panel-title">{translate('Menu-TrancheList')}</h2>
            {/* if there is no transaction you can use this code */}
            {message ? (
                <Message message={message} />
            ) : ''}

            <Box sx={{ display: 'flex' }}>
                <Accordion sx={{ display: 'nowrap', marginBottom: '10' }}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                        <Typography>{translate('Filters')}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <FormControl required component="fieldset" sx={{ m: 3, width: 250 }} variant="standard">
                            <Select id="search-field" name="search-field" value={searchField} label={translate('SearchField')} onChange={handleChange}>
                                <MenuItem value={0}><em>{translate('Select-SearchField')}</em></MenuItem>
                                <MenuItem value={1}>{translate('TrancheID')}</MenuItem>
                                <MenuItem value={2}>{translate('TrancheName')}</MenuItem>
                            </Select>
                        </FormControl>

                        <FormControl required component="fieldset" sx={{ m: 3, width: 250 }} variant="standard">
                            <TextField id="search-keyword" name="search-keyword" value={searchKeyword} label={translate('SearchKeyword')} variant="outlined" size="small" onChange={handleChange} />
                        </FormControl>

                        <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
                            <Button variant="contained" onClick={() => onClickSearch()}>{translate('btnSearch')}</Button>
                        </FormControl>
                    </AccordionDetails>
                </Accordion>
            </Box>

            <div className="gaps-3x" />
            {/* Admin List Table */}
            <table className="adminTable" style={{ width: 1024 }}>
                <tbody>
                    <tr className="adminTR">
                        <th className="adminTH" style={{ width: '7%' }} >{translate('TrancheID')}</th>
                        <th className="adminTH" style={{ width: '12%' }} >{translate('TrancheName')}</th>
                        <th className="adminTH" style={{ width: '8%' }}>{translate('TokenReleased')}</th>
                        <th className="adminTH" style={{ width: '8%' }}>{translate('TrancheRate')}</th>
                        <th className="adminTH" style={{ width: '7%' }}>{translate('PendingOrders')}</th>
                        <th className="adminTH" style={{ width: '7%' }}>{translate('PendingBonus')}</th>
                        <th className="adminTH" style={{ width: '7%' }} >{translate('TokenRemaining')}</th>
                        <th className="adminTH" style={{ width: '7%' }}>{translate('TokenSold')}</th>
                        <th className="adminTH" style={{ width: '7%' }} >{translate('Bonus')}</th>
                        <th className="adminTH" style={{ width: '7%' }} >{translate('FounderReserve')}</th>
                        <th className="adminTH" style={{ width: '8%' }} >{translate('StartDate')}</th>
                        <th className="adminTH" style={{ width: '8%' }} >{translate('EndDate')}</th>
                        <th className="adminTH" style={{ width: '7%' }} >{translate('Status')}</th>
                    </tr>
                    {props?.trancheList?.map((txn, index) => {
                        return <tr className="adminTR" key={txn.AUTORECID}>
                            <td className="adminTD" width='7%' align='center'><a href='#' onClick={event => goToModiyTranche(txn.AUTORECID)}>{txn.AUTORECID}</a></td>
                            <td className="adminTD" width='12%' align='left'><a href='#' onClick={event => goToModiyTranche(txn.AUTORECID)}>{txn.TrancheName}</a></td>
                            <td className="adminTD" width='8%' align='right'>{txn.AgathaBalance}</td>
                            <td className="adminTD" width='8%' align='right'>{txn.Rate}</td>
                            <td className="adminTD" width='7%' align='right'>{txn.PendingOrderQuantity}</td>
                            <td className="adminTD" width='7%' align='right'>{txn.PendingBonusQuantity}</td>
                            <td className="adminTD" width='7%' align='right'>{txn.AgathaRamaining}</td>
                            <td className="adminTD" width='7%' align='right'>{txn.AgathaUsed}</td>
                            <td className="adminTD" width='7%' align='right'>{txn.AgathaBonus}</td>
                            <td className="adminTD" width='7%' align='right'>{txn.FounderReserveQuantity}</td>
                            <td className="adminTD" width='8%' align='center'>{txn.StartDate}</td>
                            <td className="adminTD" width='8%' align='center'>{txn.EndDate}</td>
                            <td className="adminTD" width='7%' align='center'>{txn.ProcessStatus}</td>
                        </tr>
                    })
                    }
                </tbody>
            </table>

            <div className="gaps-2x" />
            {pageAccessRights.WriteAccess === ACCESSRIGHTSTYPE.Yes &&
                <div>
                    <button className="btn btn-primary" onClick={event => goToAddTranche(event)}>{translate('btnAddNew')}</button>
                </div>
            }
        </div>

    ) : '';
};

const mapStateToProps = state => {
    return {
        supervisor: state.remote.supervisor,
        trancheList: state.remote.trancheList
    };
};

export default connect(mapStateToProps, {
    actionGetTrancheList
})(TrancheList);
